// Recently Viewed Products Manager
const STORAGE_KEY = "cascade_recently_viewed";
const MAX_PRODUCTS = 8;

// Helper to get recently viewed products from localStorage
function getRecentlyViewed() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error("Error reading recently viewed products:", e);
    return [];
  }
}

// Helper to save recently viewed products to localStorage
function saveRecentlyViewed(products) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
  } catch (e) {
    console.error("Error saving recently viewed products:", e);
  }
}

// Helper to add a product to recently viewed
function addRecentlyViewed(productData) {
  const withoutExisting = getRecentlyViewed().filter(
    (p) => p.id !== productData.id
  );
  const next = [productData, ...withoutExisting].slice(0, MAX_PRODUCTS);
  saveRecentlyViewed(next);
}

// Initialize Alpine.js store and tracking
document.addEventListener("alpine:init", () => {
  // Create Alpine store for recently viewed products
  Alpine.store("recentlyViewed", {
    products: getRecentlyViewed(),

    getProducts() {
      return this.products;
    },

    refresh() {
      this.products = getRecentlyViewed();
    },

    // Get products excluding the current product
    getProductsExcluding(excludeId) {
      return this.products.filter((p) => p.id !== excludeId);
    },
  });
});

// Track product views (DOM-based and Alpine-based fallbacks)
if (window.location.pathname.includes("/products/")) {
  const processProduct = (product, metafields) => {
    console.log(product, " PRODUCT BB", metafields);
    if (!product || !product.id) return;
    const productData = {
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.url || `/products/${product.handle}`,
      price: product.price,
      compare_at_price: product.compare_at_price,
      available: product.available,
      featured_image:
        product.featured_image ||
        (product.featured_media
          ? product.featured_media.preview_image.src
          : ""),
      vendor: product.vendor || "",
      tags: product.tags || [],
      metafields,
    };
    addRecentlyViewed(productData);
    if (window.Alpine && Alpine.store("recentlyViewed")) {
      Alpine.store("recentlyViewed").refresh();
    }
    document.dispatchEvent(new CustomEvent("recently-viewed:updated"));
  };

  const tryFromEmbeddedJSON = () => {
    try {
      const jsonEl = document.querySelector(
        "#product-json[data-recently-viewed]"
      );
      if (jsonEl && jsonEl.textContent) {
        const product = JSON.parse(jsonEl.textContent);
        processProduct(product);
        return true;
      }
    } catch (_) {}
    return false;
  };

  const tryFromAlpine = () => {
    try {
      const productSection = document.querySelector(
        '[x-data*="Theme_Product"]'
      );
      const alpineData = productSection?._x_dataStack?.[0];
      if (alpineData?.product) {
        processProduct(alpineData.product, alpineData?.metafields);
        return true;
      }
    } catch (_) {}
    return false;
  };

  const attemptAlpineSoon = () => {
    // A couple of short retries gives Alpine time to mount
    setTimeout(tryFromAlpine, 100);
    setTimeout(tryFromAlpine, 300);
  };

  const initNow = () => {
    if (tryFromEmbeddedJSON()) return;
    if (!tryFromAlpine()) attemptAlpineSoon();
  };

  if (document.readyState !== "loading") {
    initNow();
  } else {
    document.addEventListener("DOMContentLoaded", initNow, { once: true });
  }

  // Also listen for Alpine init in case it happens after DOMContentLoaded
  document.addEventListener(
    "alpine:init",
    () => {
      setTimeout(() => {
        if (!tryFromEmbeddedJSON() && !tryFromAlpine()) {
          attemptAlpineSoon();
        }
      }, 100);
    },
    { once: true }
  );
}
